export interface SidexaPiece {
  codePiece: string;
  namePiece: string;
  reference: string;
  price: string;
  eurocode: string;
  typeCode: string;
}
